export default __webpack_public_path__ + "static/media/img5.46739192.png";